import React from 'react';
import {
  Box,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Typography,
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { ProfileIcon, LogoutIcon } from '@/static';
import CustomLink from '../CustomLink';
import styles from './styles';

type Props = {
  onLogout: () => void;
};

const DashboardMenu = ({ onLogout }: Props) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Box sx={styles.root}>
      <IconButton
        aria-controls={open ? 'menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        sx={styles.menu}
        marginThreshold={0}
      >
        <MenuItem
          component={CustomLink}
          to="/me"
          onClick={handleClose}
          sx={styles.menuItem}
        >
          <ProfileIcon />
          <Typography>My Profile</Typography>
        </MenuItem>

        <Divider variant="middle" />

        <MenuItem
          onClick={() => {
            handleClose();
            onLogout();
          }}
          sx={styles.menuItem}
        >
          <LogoutIcon />
          <Typography>Logout</Typography>
        </MenuItem>
      </Menu>
    </Box>
  );
};

export default DashboardMenu;
